import React from 'react';

const wrapStyle = {
  width: '100%',
  marginBottom: 28,
};

const bannerStyle = {
  borderRadius: 22,
  padding: '28px 24px 24px',
  border: '1px solid var(--color-border)',
  boxShadow: '0 6px 28px var(--color-shadow)',
  position: 'relative',
  overflow: 'hidden',
};

const innerRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 20,
  alignItems: 'flex-start',
};

const iconStyle = {
  fontSize: 64,
  lineHeight: 1,
  flexShrink: 0,
};

const textColStyle = {
  flex: '1 1 220px',
  minWidth: 0,
};

const titleStyle = {
  margin: 0,
  fontSize: 'clamp(1.65rem, 4.5vw, 2.1rem)',
  fontWeight: 800,
  color: 'var(--color-text)',
  letterSpacing: '-0.02em',
  lineHeight: 1.15,
};

const descStyle = {
  margin: '10px 0 0',
  fontSize: 'clamp(0.95rem, 2.2vw, 1.05rem)',
  lineHeight: 1.55,
  color: 'var(--color-text)',
  opacity: 0.82,
  fontWeight: 500,
  maxWidth: 640,
};

const metaRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 14,
  marginTop: 18,
};

const ageBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '8px 14px',
  borderRadius: 999,
  fontSize: 13,
  fontWeight: 700,
  background: 'var(--color-bg-card)',
  color: 'var(--color-text)',
  border: '1px solid var(--color-border)',
  boxShadow: '0 1px 4px var(--color-shadow)',
};

const progressBlockStyle = {
  flex: '1 1 200px',
  minWidth: 180,
  maxWidth: 360,
};

const progressLabelStyle = {
  fontSize: 12,
  fontWeight: 700,
  color: 'var(--color-text)',
  opacity: 0.55,
  marginBottom: 6,
};

const progressTrackStyle = {
  height: 10,
  borderRadius: 999,
  background: 'rgba(0,0,0,0.06)',
  border: '1px solid var(--color-border)',
  overflow: 'hidden',
};

function WorldHeader({ world }) {
  const pct = Math.min(100, Math.max(0, world.overallProgress ?? 0));

  return (
    <header style={wrapStyle}>
      <div
        style={{
          ...bannerStyle,
          background: world.bannerGradient,
        }}
      >
        <div style={innerRowStyle}>
          <div style={iconStyle} aria-hidden>
            {world.icon}
          </div>
          <div style={textColStyle}>
            <h1 style={titleStyle}>{world.title}</h1>
            <p style={descStyle}>{world.description}</p>
            <div style={metaRowStyle}>
              <span style={ageBadgeStyle}>{world.ageRangeLabel}</span>
              <div style={progressBlockStyle}>
                <div style={progressLabelStyle}>World progress</div>
                <div style={progressTrackStyle} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
                  <div
                    style={{
                      width: `${pct}%`,
                      height: '100%',
                      borderRadius: 999,
                      background: 'var(--color-primary)',
                      opacity: 0.9,
                      transition: 'width 0.3s ease',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default WorldHeader;
